// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsTriggerIamResult = objectOf({
  daily_trigger_iam_stats: objectOf({
    impression_count_by_hour: arrayOf(arrayOf(number)),
    click_count_by_hour: arrayOf(arrayOf(number)),
    button0_click_count_by_hour: arrayOf(arrayOf(number)),
    button1_click_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
